import { mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { ROOT_PADDING } from "~/styles/padding";

export const DivRootGridContainer = styled.div`
  display: grid;
  grid-gap: 32px;
  padding: ${ROOT_PADDING.PC}px;

  ${mq.sp} {
    grid-gap: 16px;
    padding: ${ROOT_PADDING.SP}px;
  }
`;
